module.exports = __webpack_public_path__ + "img/merchant.b02abdac.png";